import { BREAKPOINTS, getContentHeightCss } from 'constants/common';
import styled from 'styled-components';

export const SocialProof = () => {
  return (
    <ColumnWrapper className="split-column">
      <MainWrapper>
        <ContentBox>
          <Text1>Smarter social. No chaos.</Text1>
          <Text2>
            Thousands of marketers use Sked to plan, approve, and publish across every
            channel—without the clunky tools or cobbled-together workflows. Just one platform that
            actually keeps up, from content planning to reporting. Fast, flexible, and built for
            scale.
            <ul>
              <li>Trusted by top-performing teams</li>
              <li>Real human support, 24/7</li>
              <li>Built to scale with you—not slow you down</li>
            </ul>
          </Text2>
          <CertificateImages>
            {/* <img
              style={{ width: 180, marginRight: 16 }}
              src={`${process.env.PUBLIC_URL}/high-performer.png`}
              alt="high-performer"
            /> */}
            <Badge src={`${process.env.PUBLIC_URL}/users-love-badge.svg`} alt="high-performer" />
            <Badge src={`${process.env.PUBLIC_URL}/leader-badge.svg`} alt="high-performer" />
            <Badge
              src={`${process.env.PUBLIC_URL}/high-performer-badge.svg`}
              alt="high-performer"
            />
            <img
              style={{ width: 82, marginLeft: 16 }}
              src="https://cdn.prod.website-files.com/626209b844449fc9e345eef7/682e95e5533a5c62b484c715_logo_soc2.png"
              alt="soc2"
            />
          </CertificateImages>
          <Text3>“FINALLY our social management needs are met in one responsive platform!”</Text3>
          <Text4>Georgia B, Mid-Market (50+ EMPLOYEES)</Text4>
        </ContentBox>
      </MainWrapper>
    </ColumnWrapper>
  );
};

const Badge = styled.img`
  color: var(--primary);
  height: 74px;
  object-fit: contain;
  margin-right: 2px;
`;

const textAreaWidth = '576px';
const minTextAreaWidth = '320px';

const Text1 = styled.div`
  color: var(--text-text-primary);
  font-weight: 700;
  font-size: 40px;
  line-height: 48px;
  font-family: Gotham SSm A, Gotham SSm B, sans-serif;
  align-self: flex-start;
`;

const Text2 = styled.div`
  color: var(--Colour-Blue-700);
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  margin-top: 12px;
  align-self: flex-start;
  white-space: pre-wrap;
  ul {
    padding-inline-start: 20px;
  }
`;

const CertificateImages = styled.div`
  display: flex;
  margin-top: 48px;

  img {
    object-fit: contain;
  }
`;

const Text3 = styled.div`
  color: var(--Brand-Cosmo-500);
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  margin-top: 48px;
  text-align: center;
  font-family: Gotham SSm A, Gotham SSm B, sans-serif;
`;

const Text4 = styled.div`
  color: var(--Brand-Grape-800);
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin-top: 8px;
  text-align: center;
`;

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: ${textAreaWidth};
  min-width: ${minTextAreaWidth};
  padding-right: 14px;
  padding-left: 14px;
`;

const ColumnWrapper = styled.div`
  background-color: var(--Brand-Spice-50);
  display: none;

  @media (min-width: ${BREAKPOINTS.tablet}px) {
    display: flex;
  }
`;

const MainWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: ${getContentHeightCss()};

  @media (min-width: ${BREAKPOINTS.home.wideScreen}px) {
    align-items: flex-end;
    padding-right: 100px;
  }
`;
